/*
 * File: fontawesome.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:45 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 27, 2025 at 9:42 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { library } from '@fortawesome/fontawesome-svg-core';

// Solid Icons
import {
	faCheck,
	faTimes as faTimesSolid,
	faHeart as faHeartSolid,
	faPlus,
	faHomeLgAlt as faHomeLgAltSolid,
	faCompass as faCompassSolid,
	faStar as faStarSolid,
	faFeather as faFeatherSolid,
	faUp as faUpSolid,
	faComment as faCommentSolid,
	faMessageQuestion as faMessageQuestionSolid,
	faUserGroupSimple as faUserGroupSimpleSolid,
	faMessage as faMessageSolid,
	faLink as faLinkSolid,
	faArrowUpRight as faArrowUpRightSolid,
	faLock as faLockSolid,
	faArrowLeft as faArrowLeftSolid,
	faArrowLeftLong as faArrowLeftLongSolid,
	faArrowRightLong as faArrowRightLongSolid,
	faStar,
	faEnvelope as faEnvelopeSolid,
	faShuffle
} from '@fortawesome/pro-solid-svg-icons';

// Regular Icons
import {
	faAngleDown,
	faAngleUp,
	faTimes,
	faBars,
	faHouse,
	faUser,
	faGear,
	faQuestionCircle,
	faMoonStars,
	faSun,
	faArrowRightFromBracket,
	faPen,
	faPencil,
	faLanguage,
	faUp,
	faComment,
	faShare,
	faHeart,
	faInfoCircle,
	faArrowUpFromBracket,
	faClock,
	faEllipsis,
	faFlag,
	faPhone,
	faEnvelope,
	faArrowUpRight,
	faArrowLeft,
	faArrowTurnLeft,
	faMessage,
	faAngleRight,
	faCheck as faCheckRegular
} from '@fortawesome/pro-regular-svg-icons';

// Light Icons
import {
	faHomeLgAlt,
	faCompass,
	faMessageQuestion,
	faUserGroupSimple,
	faLink
} from '@fortawesome/pro-light-svg-icons';

// Duotone Icons
import {
	faTriangleExclamation,
	faEnvelopeDot
} from '@fortawesome/pro-duotone-svg-icons';

// Brand Icons
import {
	faFacebook,
	faFacebookF,
	faInstagram,
	faTwitter,
	faRedditAlien,
	faPinterestP,
	faLinkedinIn,
	faTiktok,
	faXTwitter,
	faWhatsapp
} from '@fortawesome/free-brands-svg-icons';


/**
 * Init
 */

export function loadIcons() {

	// Add icons to library
	library.add(
		faCheck,
		faHeart,
		faAngleDown,
		faAngleUp,
		faTimes,
		faBars,
		faHouse,
		faUser,
		faGear,
		faQuestionCircle,
		faMoonStars,
		faSun,
		faArrowRightFromBracket,
		faFacebook,
		faFacebookF,
		faInstagram,
		faTwitter,
		faRedditAlien,
		faPinterestP,
		faLinkedinIn,
		faTiktok,
		faXTwitter,
		faWhatsapp,
		faPlus,
		faPen,
		faPencil,
		faHomeLgAlt,
		faCompass,
		faStar,
		faHomeLgAltSolid,
		faCompassSolid,
		faStarSolid,
		faFeatherSolid,
		faLanguage,
		faUp,
		faComment,
		faShare,
		faUpSolid,
		faCommentSolid,
		faHeartSolid,
		faMessageQuestion,
		faMessageQuestionSolid,
		faUserGroupSimpleSolid,
		faUserGroupSimple,
		faMessage,
		faMessageSolid,
		faLinkSolid,
		faArrowUpRightSolid,
		faArrowUpRight,
		faLink,
		faLockSolid,
		faArrowLeftLongSolid,
		faArrowRightLongSolid,
		faInfoCircle,
		faArrowUpFromBracket,
		faTriangleExclamation,
		faEnvelopeDot,
		faClock,
		faEllipsis,
		faFlag,
		faEnvelopeSolid,
		faPhone,
		faEnvelope,
		faArrowLeftSolid,
		faArrowLeft,
		faArrowTurnLeft,
		faAngleRight,
		faTimesSolid,
		faShuffle,
		faCheckRegular
	);
}
